<template>
  <div class="knowledgeListPage">
    <div class="titleBox">
      <div class="titleLeft" @click="goBack">
        <img src="../../assets/images/titleArrow.png" alt="" />
      </div>
      <div class="titleCentre">{{ title }}</div>
      <div class="titleRight" @click="goCollectList">我的收藏</div>
    </div>

    <div class="bannerBox">
      <img :src="knowledgeHomeImage" alt="" @click="handleKnowledgeHomeClick" />
    </div>

    <div class="summaryCard">
      <div class="summaryItem">
        <div class="num">{{ masterNum }}</div>
        <div class="label">已掌握</div>
      </div>
      <div class="divider"></div>
      <div class="summaryItem">
        <div class="num">{{ unMasterNum }}</div>
        <div class="label">未掌握</div>
      </div>
    </div>

    <div class="listWrap">
      <div
        class="listItem"
        v-for="(item, index) in standingList"
        :key="item.categoryId || index"
        @click="goKnowledgeDetails(item)"
      >
        <div class="topRow">
          <div class="titleArea">
            <span class="name">{{ item.categoryName }}</span>
            <span class="count"
              >({{ item.masteredNum }}/{{ item.totalNum }})</span
            >
            <span v-if="item.continueFlag" class="continueTag">继续做</span>
          </div>
          <div class="arrow">
            <img src="../../assets/icons/knowledgeArrowTwo.png" alt="" />
          </div>
        </div>
        <div class="progressBar">
          <div
            class="progressInner"
            :style="{ width: getPercent(item) + '%' }"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { statistics } from "@/api/knowledge/index.js";

export default {
  data() {
    return {
      title: "",
      masterNum: 0,
      unMasterNum: 0,
      standingList: [],
    };
  },
  created() {
    this.label = this.$route.params.label;
    this.getStatisticsData();
  },
  methods: {
    getBannerPrefixFromRoute() {
      const routePrefix =
        this.$route.query.filePrefix ||
        this.$route.query.prefix ||
        this.$route.query.origin ||
        "";
      if (routePrefix) {
        localStorage.setItem("bannerFilePrefix", routePrefix);
      }
      return (
        routePrefix ||
        localStorage.getItem("bannerFilePrefix") ||
        window.location.origin ||
        ""
      );
    },
    formatKnowledgeImageUrl(url) {
      if (!url) {
        return "";
      }
      if (/^(https?:)?\/\//i.test(url)) {
        return encodeURI(url);
      }
      const imgPrefix = String(this.imgUrl || `${window.location.origin}/file/`).replace(
        /\/+$/,
        ""
      );
      const normalizedPath = String(url).startsWith("/")
        ? String(url)
        : `/${String(url)}`;
      if (/\/file$/i.test(imgPrefix) && normalizedPath.startsWith("/file/")) {
        return encodeURI(`${imgPrefix}${normalizedPath.replace(/^\/file/, "")}`);
      }
      return encodeURI(`${imgPrefix}${normalizedPath}`);
    },
    toValidNumber(value) {
      if (value === undefined || value === null || value === "") {
        return null;
      }
      const numberValue = Number(value);
      return Number.isNaN(numberValue) ? null : numberValue;
    },
    getRouteParams() {
      const paramsType = this.toValidNumber(this.$route.params.type);
      const paramsCode = this.toValidNumber(this.$route.params.code);
      const queryType = this.toValidNumber(this.$route.query.type);
      const queryCode = this.toValidNumber(this.$route.query.code);
      const pathParts = (this.$route.path || "").split("/").filter(Boolean);
      const pathType = this.toValidNumber(pathParts[pathParts.length - 2]);
      const pathCode = this.toValidNumber(pathParts[pathParts.length - 1]);

      const type = paramsType ?? queryType ?? pathType;
      const code = paramsCode ?? queryCode ?? pathCode;

      return { type, code };
    },
    getPercent(item) {
      const total = Number(item.totalNum || 0);
      const done = Number(item.masteredNum || 0);
      if (!total) {
        return 0;
      }
      return Math.min(100, Math.max(0, Math.round((done / total) * 100)));
    },
    async getStatisticsData() {
      const { type, code } = this.getRouteParams();
      this.title = this.$route.query.label || this.title;

      if (type === null || code === null) {
        return;
      }

      const { data } = await statistics(type, code);
      this.masterNum = (data && data.masterNum) || 0;
      this.unMasterNum = (data && data.unMasterNum) || 0;
      this.standingList = (data && data.agentMedicalKnowledgeNum) || [];
    },
    goBack() {
      this.$router.go(-1);
    },
    goKnowledgeDetails(item) {
      const { type, code } = this.getRouteParams();
      const filePrefix = this.getBannerPrefixFromRoute();
      this.$router.push({
        path: "/knowledgeDetails",
        query: {
          medicalKnowledgeId: item.medicalKnowledgeId,
          categoryId: item.categoryId,
          categoryName: item.categoryName,
          type,
          code,
          filePrefix,
        },
      });
    },
    goCollectList() {
      const { code } = this.getRouteParams();
      const filePrefix = this.getBannerPrefixFromRoute();
      this.$router.push({
        path: "/collectList",
        query: {
          type: 1,
          code,
          filePrefix,
        },
      });
    },
    handleKnowledgeHomeClick() {
      if (!this.knowledgePointJumpUrl) {
        return;
      }
      window.location.href = this.knowledgePointJumpUrl;
    },
  },
  computed: {
    knowledgeHomeImage() {
      const configImage = this.$store.getters.knowledgePointImageUrl;
      return (
        this.formatKnowledgeImageUrl(configImage) ||
        require("../../assets/icons/knowledgHome.png")
      );
    },
    knowledgePointJumpUrl() {
      return this.$store.getters.knowledgePointJumpUrl || "";
    },
  },
};
</script>

<style lang="scss" scoped>
.knowledgeListPage {
  background-color: #f4f7fa;

  .titleBox {
    padding: 44px 16px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .titleLeft {
      text-align: center;
      line-height: 20px;
      width: 20px;
      height: 20px;
      img {
        width: 20px;
        height: 20px;
      }
    }

    .titleRight {
      min-width: 56px;
      text-align: right;
      font-family: PingFangSC, Pin gFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #6f7483;
      line-height: 20px;
    }

    .titleCentre {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 33px;
      transform: scale(0.5);
      transform-origin: center;
      color: #2f3445;
      white-space: nowrap;
    }
  }

  .bannerBox {
    padding: 10px 15px;
    width: 100%;

    img {
      width: 100%;
      height: 100px;
    }
  }

  .summaryCard {
    margin: 12px 16px;
    height: 88px;
    background: #ffffff;
    border-radius: 12px;
    display: flex;
    align-items: center;

    .summaryItem {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;

      .num {
        font-family: DINAlternate, DINAlternate;
        font-weight: 500;
        font-size: 20px;
        color: #2f2f46;
        line-height: 24px;
      }

      .label {
        margin-top: 5px;
        font-family: PingFangSC, PingFang SC;
        font-size: 12px;
        color: #8f91a1;
      }
    }

    .divider {
      width: 1px;
      height: 32px;
      background: #e9ebf1;
    }
  }

  .listWrap {
    margin: 12px 16px 0;

    .listItem {
      background: #ffffff;
      border-radius: 10px;
      padding: 14px 12px 12px;
      margin-bottom: 10px;

      .topRow {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .titleArea {
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        .name {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 16px;
          color: #343949;
        }

        .count {
          margin-left: 8px;
          font-family: PingFangSC, PingFang SC;
          font-size: 16px;
          color: #8f95a4;
        }

        .continueTag {
          margin-left: 10px;
          padding: 0 8px;
          height: 22px;
          line-height: 22px;
          background: #fff4df;
          border: 1px solid #ffd8a1;
          border-radius: 10px;
          font-family: PingFangSC, PingFang SC;
          font-size: 13px;
          color: #f4a130;
        }
      }

      .arrow {
        width: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .progressBar {
        margin-top: 12px;
        width: 100%;
        height: 12px;
        border-radius: 6px;
        background: #eef0f4;
        overflow: hidden;

        .progressInner {
          height: 100%;
          border-radius: 6px;
          background: #3b79f2;
        }
      }
    }
  }
}
</style>
